import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-5edc7cf3"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "description-header-title"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "description-header-content"
}, [/*#__PURE__*/_createElementVNode("span", null, "维护车架信息")], -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_layout_breadcrumb = _resolveComponent("layout-breadcrumb");
  const _component_el_option = _resolveComponent("el-option");
  const _component_el_select = _resolveComponent("el-select");
  const _component_el_form_item = _resolveComponent("el-form-item");
  const _component_el_col = _resolveComponent("el-col");
  const _component_el_input = _resolveComponent("el-input");
  const _component_el_date_picker = _resolveComponent("el-date-picker");
  const _component_el_row = _resolveComponent("el-row");
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_form = _resolveComponent("el-form");
  const _component_form_page = _resolveComponent("form-page");
  const _directive_permission = _resolveDirective("permission");
  return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_layout_breadcrumb, {
    topMenuId: _ctx.topMenuId,
    onChangeTopToMenu: _ctx.changeTopToMenu,
    topMenuClick: _ctx.topMenuClick
  }, {
    description: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("span", null, _toDisplayString(`${$data.edit ? '修改' : '增加'}车架`), 1)]), _hoisted_2]),
    _: 1
  }, 8, ["topMenuId", "onChangeTopToMenu", "topMenuClick"]), _createVNode(_component_form_page, null, {
    default: _withCtx(() => [_createVNode(_component_el_form, {
      model: $data.formModel,
      rules: $data.formRules,
      class: "normal-form",
      ref: "formRef",
      "label-width": "160px"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_row, {
        gutter: 10
      }, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          span: 12
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "仓库",
            prop: "warehouseId"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_select, {
              style: {
                "width": "100%"
              },
              disabled: $data.edit,
              modelValue: $data.formModel.warehouseId,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.formModel.warehouseId = $event),
              filterable: "",
              remote: "",
              "reserve-keyword": "",
              placeholder: "请选择仓库",
              "remote-method": $options.remoteWarehouse,
              loading: _ctx.loading
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.warehouses, item => {
                return _openBlock(), _createBlock(_component_el_option, {
                  key: item.id,
                  label: item.name,
                  value: item.id
                }, null, 8, ["label", "value"]);
              }), 128))]),
              _: 1
            }, 8, ["disabled", "modelValue", "remote-method", "loading"])]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 12
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "车架编号",
            prop: "frameCode"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: $data.formModel.frameCode,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.formModel.frameCode = $event),
              placeholder: "请输入序列号"
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 12
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "厂家",
            prop: "manufacturer"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: $data.formModel.manufacturer,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $data.formModel.manufacturer = $event),
              placeholder: "请输入厂家"
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 12
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "车牌号"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: $data.formModel.plateNo,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => $data.formModel.plateNo = $event),
              placeholder: "请输入车牌号"
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }), $data.formModel.plateNo ? (_openBlock(), _createBlock(_component_el_col, {
          key: 0,
          span: 12
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "上牌时间",
            prop: "plateTime"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_date_picker, {
              modelValue: $data.formModel.plateTime,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => $data.formModel.plateTime = $event),
              type: "datetime",
              "value-format": "YYYY-MM-DD HH:mm:ss",
              format: "YYYY-MM-DD HH:mm:ss",
              style: {
                "width": "100%"
              }
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        })) : _createCommentVNode("", true), _createVNode(_component_el_col, {
          span: 12
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "保险单号"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: $data.formModel.insureCode,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => $data.formModel.insureCode = $event),
              placeholder: "请输入保险单号"
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 12
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "保险公司"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: $data.formModel.insureCompany,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => $data.formModel.insureCompany = $event),
              placeholder: "请输入保险公司"
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 12
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "保险名称"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: $data.formModel.insureName,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => $data.formModel.insureName = $event),
              placeholder: "请输入保险名称"
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 24
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "保险时间"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_date_picker, {
              modelValue: $data.formModel.dates,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => $data.formModel.dates = $event),
              type: "daterange",
              "range-separator": "至",
              "start-placeholder": "开始日期",
              "end-placeholder": "结束日期",
              "value-format": "YYYY-MM-DD",
              format: "YYYY-MM-DD",
              style: {
                "width": "100%"
              }
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_form_item, null, {
        default: _withCtx(() => [_withDirectives((_openBlock(), _createBlock(_component_el_button, {
          type: "primary",
          onClick: $options.submitForm
        }, {
          default: _withCtx(() => [_createTextVNode("保存 ")]),
          _: 1
        }, 8, ["onClick"])), [[_directive_permission, ['deviceFrame_add', 'deviceFrame_edit']]]), _createVNode(_component_el_button, {
          onClick: _cache[9] || (_cache[9] = () => {
            this.$router.go(-1);
          })
        }, {
          default: _withCtx(() => [_createTextVNode("取消")]),
          _: 1
        })]),
        _: 1
      })]),
      _: 1
    }, 8, ["model", "rules"])]),
    _: 1
  })]);
}